import { AlertCircleIcon } from "lucide-react";

interface BillingNoticeProps {
  readonly description: string;
  readonly title?: string;
}

export function BillingNotice({ description, title }: BillingNoticeProps) {
  return (
    <div className="flex items-start gap-lg rounded-xl border border-border-primary bg-bg-primary p-lg">
      <AlertCircleIcon
        aria-hidden="true"
        className="mt-px shrink-0 text-fg-warning-primary"
        size={20}
      />
      <div className="flex flex-col gap-xxs text-sm">
        {title && (
          <span className="font-semibold text-text-secondary">{title}</span>
        )}
        <span
          className={
            title ? "text-text-tertiary" : "font-semibold text-text-secondary"
          }
        >
          {description}
        </span>
      </div>
    </div>
  );
}
